import { Button } from "@/components/ui/button";
import { logoutReturnTo, nativeLogoutOpts } from "@/native/auth";
import { clearSessionQueryCaches } from "@/queryPersistence";
import { useAuth0 } from "@auth0/auth0-react";
import { ErrorDisplay } from "@cohesive/ui-components";

export function ErrorPage({
  title = "Error",
  message = "An unknownerror occurred",
}: {
  title: string;
  message: string;
}) {
  const { logout } = useAuth0();

  return (
    <ErrorDisplay
      title={title}
      message={message}
      footer={
        <Button
          onClick={() => {
            clearSessionQueryCaches();
            logout({
              logoutParams: { returnTo: logoutReturnTo() },
              ...nativeLogoutOpts(),
            });
          }}
        >
          Logout
        </Button>
      }
    />
  );
}

export default ErrorPage;
